<template>
    <Title_Base :icon="icon">
        <template v-slot:title>
            <template v-if="loading || !item">
                {{ $t('servicesystem.common_objects.commonterms.loading_placeholder',
        { pkey: $t('servicesystem.common_objects.machine.machine') }) }}
            </template>
            <template v-else>
                {{ machineGeneralizerText(item) }}
                <span style="color: var(--v-primary-base);" class="ml-1">{{ machineIdentifierText(item) }}</span>
            </template>
        </template>
    </Title_Base>
</template>


<script>
import MachineMixin from "@/helpers/Mixins/MachineMixin.js";
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
    name: 'Title_Machine',
    props: {},
    components: {
        Title_Base,
    },
    mixins: [MachineMixin],

    data() {
        return {
            entityName: EntityNames.Machine,
        };
    },

    methods: {},

    computed: {
        icon() {
            return "$machine";
        },

        item() {
            return this.$store.getters["entitycontainerstore/getEntity"](this.entityName);
        },

        loading() {
            return this.$store.getters["entitycontainerstore/getEntityLoading"](this.entityName);
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>